import store from '@/store/store';

export const getTimezoneOffset = (): number => {
  const { session = {} } = store.state['session'];
  const timezoneOffset: number = parseInt(session.timezone);
  if (!timezoneOffset) {
    return 0;
  }
  return timezoneOffset;
};
